'use client'

import { CSSProperties } from 'react'

import { cn } from '@/lib/utils'

type IconProps = {
  className?: string
  icon: string
  style?: CSSProperties
}

export default function Icon({ icon, className, style }: IconProps) {
  return (
    <div className={cn('flex items-center justify-center text-base', className)} style={style}>
      <i className={icon}></i>
    </div>
  )
}
